const INJECTED_ROUTE = Symbol('injected-route');

/** Mark a context whose `route` came from `RouteProvider`. */
export function markInjectedRouteContext(
  context: Record<string, unknown>,
): void {
  Object.defineProperty(context, INJECTED_ROUTE, {
    value: true,
    enumerable: false,
  });
}

/** True when `route` is the host-injected bag, not a data source. */
export function isInjectedRouteContext(context: unknown): boolean {
  return (
    typeof context === 'object' &&
    context !== null &&
    (context as Record<symbol, unknown>)[INJECTED_ROUTE] === true
  );
}
